import { ReactNode } from "react";
import View from "../atoms/view";
import theme from "../../theme";
import { Styles } from "../../constants/theme";
import { Card } from "../atoms/card";
import { H3, Label, SubTitle, } from "../atoms/text";

export type InfoSummaryItem = {
  icon: ReactNode;
  label: string;
  value?: string | number | null;
};

type InfoSummaryProps = {
  items: InfoSummaryItem[];
};

export const InfoSummary = ({ items }: InfoSummaryProps) => (
  <Card extend={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "24px" }}>
    {items.map((item) => (
      <View key={item.label} extend={styles.item}>
        <View extend={styles.icon}>{item.icon}</View>
        <View extend={styles.text}>
          <Label noPadding extend={{ fontSize: "13px" }} >{item.label}</Label>
          <SubTitle>{item.value ?? "—"}</SubTitle>
        </View>
      </View>
    ))}
  </Card>
);

const styles = {
  card: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "24px",
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: `${Styles.BorderRadius}px`,
    padding: "20px 24px",
  },
  item: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
    flex: 1,
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.colors.grey,
    fontSize: "28px",
    flexShrink: 0,
  },
  text: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  }
};
